export const TROPHY_BASE_URL = "https://m.np.playstation.com/api/trophy";
